module.exports = __webpack_public_path__ + "img/bro.9a06b1d1.svg";